import moment from 'moment';
/**
 * drawType 绘制类型
 * drawName 绘制名称
 * rotationFirst 风向图片用的角度
 * CoordinatesFirst  风向第一个点
 */

function getDrawParams(obj) {
    let {
        drawType,
        drawName,
        drawObj,
        longitude,
        latitude,
        positions,
        distance,
        color,
        width,
        rotationFirst,
        CoordinatesFirst,
        location,
        area,
        fillColor,
        center,
        speed,
        pollutant,
        pollutantDistance,
        interceptTime,
        mark,
        radius,
    } = obj;
    // 三维
    let threeGeometry = {
        feature: {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: positions,
            },
            properties: null,
        },
        subType: 'StraightArrow',
        options: {},
        symbol: {
            lineColor: '#29FFF2',
            polygonFill: '#29FFF288',
            polygonOpacity: 0.5,
        },
    };
    let tempObj = {
        type: 5,
        status: 0,
        state: 0,
        json: {
            '2d': {
                drawType,
                drawName,
                longitude,
                latitude,
                distance,
                positions,
                color,
                width,
                rotationFirst,
                CoordinatesFirst,
                location,
                area,
                fillColor,
                center,
                speed,
                pollutant,
                pollutantDistance,
                interceptTime,
                mark,
                radius,
            },
            '3d': {
                drawType,
                drawName,
                threeGeometry,
                longitude,
                latitude,
                distance,
                positions,
                color,
                width,
                rotationFirst,
                CoordinatesFirst,
                location,
                area,
                fillColor,
                center,
                speed,
                pollutant,
                pollutantDistance,
                interceptTime,
                mark,
                radius,
            },
        },
        name: drawName,
        obj: drawObj,
        sysId: 'emergency2', // 项目名称
        time: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
    };
    tempObj.json = JSON.stringify(tempObj.json);
    return tempObj;
}
export default getDrawParams;
